module.exports = __webpack_public_path__ + "static/media/Demirbas.3a923b84.png";